import {
  ACTIVITY_LOG_VIEW,
  AREAPLAN_EDIT,
  AREAPLAN_VIEW,
  BULLETIN_BOARD_ACCESS,
  BULLETIN_BOARD_EDIT_ALL,
  BULLETIN_BOARD_SEND,
  BULLETIN_CREATE_EDIT_OWN,
  COMPETENCIES_VIEW_OTHER_USER_COMPETENCIES,
  CONTACTS_MANAGE,
  CONTACTS_VIEW,
  CUSTOMER_REGISTRY_ACCESS,
  DEFECTS_DEFECT_LISTS_ACCESS,
  DEFECTS_DEFECT_LISTS_CREATE,
  DEFECTS_DEFECT_LISTS_VIEW,
  DEFECTS_DEFECTS_EDIT,
  DEVICES_MANAGE,
  EDIT_OTHER_USERS_RECORDS,
  EDIT_PERMISSIONS_OF_PROJECT,
  EXPENSE_TRACKING_ACCESS,
  FILINGS_MANAGE,
  FIRESTOP_DOCUMENTATION_ACCESS,
  FORMS_ACCESS,
  FORMS_AUTOMATION_MANAGE,
  FORMS_DELETE,
  FORMS_HOT_WORK_PERMIT_FORMS_ACCESS,
  FORMS_HOT_WORK_PERMIT_FORMS_CREATE_EDIT_OWN,
  FORMS_HOT_WORK_PERMIT_FORMS_EDIT_ALL,
  FORMS_MANAGE_TEMPLATES,
  FORMS_MASS_EDIT_FORMS,
  FORMS_NON_CONFORMANCE_REPORTS_ACCESS,
  FORMS_NON_CONFORMANCE_REPORTS_CREATE_EDIT_OWN,
  FORMS_NON_CONFORMANCE_REPORTS_EDIT_ALL,
  FORMS_ORIENTATION_FORMS_ACCESS,
  FORMS_ORIENTATION_FORMS_CREATE_EDIT_OWN,
  FORMS_ORIENTATION_FORMS_DELETE,
  FORMS_ORIENTATION_FORMS_MANAGE,
  FORMS_PERSONNEL_LIFT_USAGE_PERMITS_ACCESS,
  FORMS_PERSONNEL_LIFT_USAGE_PERMITS_CREATE_EDIT_OWN,
  FORMS_PERSONNEL_LIFT_USAGE_PERMITS_EDIT_ALL,
  FORMS_SELF_HANDOVER_FORMS_ACCESS,
  FORMS_SELF_HANDOVER_FORMS_CREATE_EDIT_OWN,
  FORMS_SELF_HANDOVER_FORMS_EDIT_ALL,
  FORMS_SELF_SUPERVISION_MEMOS_ACCESS,
  FORMS_SELF_SUPERVISION_MEMOS_CREATE_EDIT_OWN,
  FORMS_SELF_SUPERVISION_MEMOS_EDIT_ALL,
  FORMS_SEND,
  FORMS_SUBSTATION_COMMISSIONING_INSPECTION_REPORTS_ACCESS,
  FORMS_SUBSTATION_COMMISSIONING_INSPECTION_REPORTS_CREATE_EDIT_OWN,
  FORMS_SUBSTATION_COMMISSIONING_INSPECTION_REPORTS_EDIT_ALL,
  FORMS_TEMPLATE_FORMS_ACCESS,
  FORMS_TEMPLATE_FORMS_CREATE_EDIT_OWN,
  FORMS_TEMPLATE_FORMS_EDIT_ALL,
  FORMS_TR_METERS_ACCESS,
  FORMS_TR_METERS_CREATE_EDIT_OWN,
  FORMS_TR_METERS_EDIT_ALL,
  FORMS_WEEKLY_REVIEW_FORMS_ACCESS,
  FORMS_WEEKLY_REVIEW_FORMS_CREATE_EDIT_OWN,
  FORMS_WEEKLY_REVIEW_FORMS_EDIT_ALL,
  FORMS_WORKSITE_JOURNALS_ACCESS,
  FORMS_WORKSITE_JOURNALS_CREATE_EDIT_OWN,
  FORMS_WORKSITE_JOURNALS_EDIT_ALL,
  FORMS_WORKSITE_JOURNALS_SIGN_AS_FOREMAN_IN_CHARGE,
  FORMS_WORKSITE_JOURNALS_SIGN_AS_SUPERVISOR,
  FORMS_WORKSITE_STATUS_DECLARATIONS_ACCESS,
  FORMS_WORKSITE_STATUS_DECLARATIONS_CREATE_EDIT_OWN,
  FORMS_WORKSITE_STATUS_DECLARATIONS_EDIT_ALL,
  GALLERY_ACCESS,
  GALLERY_ADD_PICTURES_TO_ROOT,
  GALLERY_MANAGE_FLOORPLANS,
  GALLERY_VIEW_MEDIA_ADDER_INFO,
  GALLERY_VIEW_OTHER_USERS_IMAGES,
  MANAGE_COMPANY_RESOURCES,
  NEROBOTTI_ACCESS,
  NEROBOTTI_AUTOMATION_MANAGE,
  ORGANIZATION_CHART_EMPLOYEE_INFO_VIEW,
  ORGANIZATION_CHART_MANAGE_ORGANIZATIONS,
  ORGANIZATION_CHART_VIEW,
  ORIENTATION_QUIZ_IGNORE_ORIENTATION_REQUIREMENT,
  ORIENTATION_QUIZ_MANAGE,
  PROJECT_APPROVALS_MANAGE,
  PROJECT_BANK_ACCESS,
  PROJECT_BANK_DELETE,
  PROJECT_BANK_DELETE_OWN,
  PROJECT_BANK_EDIT,
  PROJECT_BANK_EDIT_OWN,
  PROJECT_BANK_MOVE_ANY,
  PROJECT_BANK_MOVE_OWN,
  PROJECT_BANK_PRIVATE_FOLDER_ACCESS,
  PROJECT_BANK_TILAAJAVASTUU_DOCUMENTS_MANAGE,
  PROJECT_BANK_TILAAJAVASTUU_DOCUMENTS_VIEW,
  PROJECT_CHAT_ACCESS,
  PROJECT_CHAT_MEETINGS_MANAGE,
  PROJECT_CHAT_RECORD_VIDEO_CHAT,
  PROJECT_CHAT_VIEW_RECORDINGS,
  PROJECT_CHAT_VIEW_ALL_MEETING_NOTES,
  PROJECT_CREATE,
  PROJECT_EDIT,
  PROJECT_EMAIL_READ,
  PROJECT_EMAIL_SEE_READ_BY_OTHERS,
  PROJECT_EMAIL_SEND,
  PROJECT_MAP_ACCESS,
  PROJECT_STATUS_EDIT,
  PROJECT_TIMELINES_ASSIGNMENT_CONNECTIONS_MANAGE,
  PROJECT_TIMELINES_ASSIGNMENTS_BASED_VALUES_VIEW,
  PROJECT_TIMELINES_EDIT,
  PROJECT_TIMELINES_VIEW,
  PROJECTS_OWN_ARCHIVED_PROJECTS_VIEW,
  PROJECTS_OWN_AUTOMATIC_JOIN,
  RECORDS_ABSENCE_CREATE,
  RECORDS_ALLOW_MULTIPLE_CLOCK_IN_OWN_PROJECTS,
  RECORDS_APPROVE,
  RECORDS_CHECK_BILLED_TIMES,
  RECORDS_CHECK_CLOCKED_TIMES,
  RECORDS_CREATE,
  RECORDS_CREATE_OTHER_USERS_RECORDS,
  RECORDS_EDIT_OWN_RECORDS,
  RECORDS_SEND_TO_APPROVAL,
  RECORDS_VIEW_OTHER_USERS_RECORDS_DETAILED_INFORMATION,
  RENOLOG_ACCESS,
  RENOLOG_MANAGE,
  RENOLOG_ORDER,
  RENOLOG_SHARE_ACCESS,
  REPORTS_GENERATE_EMPLOYEE_REPORT,
  REPORTS_GENERATE_ORIENTATION_REPORT,
  REPORTS_GENERATE_PROJECT_LIST_REPORT,
  RESOURCES_ADD_EMPLOYEES_TO_PROJECTS,
  RESOURCES_COMPETENCIES_MANAGE,
  RESOURCES_EDIT_SALARIES,
  RESOURCES_REMOVE_FROM_PROJECT,
  RESOURCES_VIEW_CLOCKED_IN,
  SALARIES_TRANSFER_SEND,
  SALARIES_TYPES_EDIT,
  SUBCONTRACTORS_RECORDS_VIEW,
  VIEW_OTHER_RESOURCES,
  VIEW_OTHER_USERS_RECORDS,
  VIEW_SUBPROJECTS,
  WORK_CALENDAR_ACCESS,
  WORK_CALENDAR_EDIT_ALL_OWN_BUSINESS_RECORDS,
  WORK_CALENDAR_VIEW_ALL_OWN_BUSINESS_RECORDS,
  WORK_CALENDAR_WORK_TIME_SALDOS_VIEW,
} from './permissions';

export const EMPLOYER_TOGGLABLE_PERMISSIONS = [
  RECORDS_ALLOW_MULTIPLE_CLOCK_IN_OWN_PROJECTS,
  PROJECTS_OWN_AUTOMATIC_JOIN,
  PROJECTS_OWN_ARCHIVED_PROJECTS_VIEW,
  SUBCONTRACTORS_RECORDS_VIEW,
  RESOURCES_EDIT_SALARIES,
  RESOURCES_COMPETENCIES_MANAGE,
  RESOURCES_ADD_EMPLOYEES_TO_PROJECTS,
  CUSTOMER_REGISTRY_ACCESS,
  CONTACTS_VIEW,
  CONTACTS_MANAGE,
  DEVICES_MANAGE,
  SALARIES_TRANSFER_SEND,
  SALARIES_TYPES_EDIT,
  GALLERY_ADD_PICTURES_TO_ROOT,
  WORK_CALENDAR_VIEW_ALL_OWN_BUSINESS_RECORDS,
  WORK_CALENDAR_EDIT_ALL_OWN_BUSINESS_RECORDS,
  WORK_CALENDAR_WORK_TIME_SALDOS_VIEW,
];

export const PROJECT_TOGGLABLE_PERMISSIONS = [
  VIEW_OTHER_RESOURCES,
  MANAGE_COMPANY_RESOURCES,
  RESOURCES_REMOVE_FROM_PROJECT,
  RESOURCES_VIEW_CLOCKED_IN,
  RECORDS_EDIT_OWN_RECORDS,
  EDIT_OTHER_USERS_RECORDS,
  VIEW_OTHER_USERS_RECORDS,
  RECORDS_VIEW_OTHER_USERS_RECORDS_DETAILED_INFORMATION,
  RECORDS_CREATE_OTHER_USERS_RECORDS,
  EDIT_PERMISSIONS_OF_PROJECT,
  BULLETIN_BOARD_ACCESS,
  BULLETIN_BOARD_EDIT_ALL,
  BULLETIN_CREATE_EDIT_OWN,
  BULLETIN_BOARD_SEND,
  FILINGS_MANAGE,
  FORMS_ACCESS,
  FORMS_DELETE,
  FORMS_SEND,
  FORMS_MANAGE_TEMPLATES,
  FORMS_AUTOMATION_MANAGE,
  FORMS_ORIENTATION_FORMS_MANAGE,
  FORMS_ORIENTATION_FORMS_DELETE,
  FORMS_MASS_EDIT_FORMS,
  GALLERY_ACCESS,
  GALLERY_VIEW_OTHER_USERS_IMAGES,
  GALLERY_VIEW_MEDIA_ADDER_INFO,
  GALLERY_MANAGE_FLOORPLANS,
  PROJECT_BANK_ACCESS,
  PROJECT_BANK_DELETE,
  PROJECT_BANK_DELETE_OWN,
  PROJECT_BANK_EDIT,
  PROJECT_BANK_EDIT_OWN,
  PROJECT_BANK_MOVE_ANY,
  PROJECT_BANK_MOVE_OWN,
  PROJECT_BANK_TILAAJAVASTUU_DOCUMENTS_VIEW,
  PROJECT_BANK_TILAAJAVASTUU_DOCUMENTS_MANAGE,
  PROJECT_BANK_PRIVATE_FOLDER_ACCESS,
  PROJECT_CREATE,
  PROJECT_EDIT,
  PROJECT_STATUS_EDIT,
  PROJECT_MAP_ACCESS,
  EXPENSE_TRACKING_ACCESS,
  VIEW_SUBPROJECTS,
  RECORDS_CHECK_CLOCKED_TIMES,
  RECORDS_CHECK_BILLED_TIMES,
  RECORDS_APPROVE,
  RECORDS_SEND_TO_APPROVAL,
  RECORDS_ABSENCE_CREATE,
  PROJECT_APPROVALS_MANAGE,
  PROJECT_TIMELINES_EDIT,
  PROJECT_TIMELINES_VIEW,
  PROJECT_TIMELINES_ASSIGNMENTS_BASED_VALUES_VIEW,
  PROJECT_TIMELINES_ASSIGNMENT_CONNECTIONS_MANAGE,
  ORIENTATION_QUIZ_MANAGE,
  ORIENTATION_QUIZ_IGNORE_ORIENTATION_REQUIREMENT,
  COMPETENCIES_VIEW_OTHER_USER_COMPETENCIES,
  REPORTS_GENERATE_ORIENTATION_REPORT,
  REPORTS_GENERATE_EMPLOYEE_REPORT,
  REPORTS_GENERATE_PROJECT_LIST_REPORT,
  DEFECTS_DEFECT_LISTS_ACCESS,
  DEFECTS_DEFECT_LISTS_VIEW,
  DEFECTS_DEFECT_LISTS_CREATE,
  DEFECTS_DEFECTS_EDIT,
  RECORDS_CREATE,
  AREAPLAN_VIEW,
  AREAPLAN_EDIT,
  PROJECT_EMAIL_READ,
  PROJECT_EMAIL_SEND,
  PROJECT_EMAIL_SEE_READ_BY_OTHERS,
  PROJECT_CHAT_ACCESS,
  PROJECT_CHAT_RECORD_VIDEO_CHAT,
  PROJECT_CHAT_VIEW_RECORDINGS,
  PROJECT_CHAT_VIEW_ALL_MEETING_NOTES,
  PROJECT_CHAT_MEETINGS_MANAGE,
  ORGANIZATION_CHART_VIEW,
  ORGANIZATION_CHART_MANAGE_ORGANIZATIONS,
  ORGANIZATION_CHART_EMPLOYEE_INFO_VIEW,
  WORK_CALENDAR_ACCESS,
  RENOLOG_ACCESS,
  RENOLOG_ORDER,
  RENOLOG_MANAGE,
  RENOLOG_SHARE_ACCESS,
  FIRESTOP_DOCUMENTATION_ACCESS,
  ACTIVITY_LOG_VIEW,
  NEROBOTTI_ACCESS,
  NEROBOTTI_AUTOMATION_MANAGE,
];

// Per-form-type togglable permissions. Kept out of PROJECT_TOGGLABLE_PERMISSIONS
// so the legacy `permission.includes('forms')` matcher in
// returnTogglableProjectPermissionsByFeature does not surface them inside the
// flat Lomakkeet group — they belong to the nested form-type cards instead.
//
// This list is also what the dialogs' "Anna kaikki lomaketyyppikohtaiset
// oikeudet" button grants in one click, so the worksite-journal signer rows
// below are part of that bulk grant.
export const FORM_TYPE_PROJECT_TOGGLABLE_PERMISSIONS = [
  FORMS_WORKSITE_STATUS_DECLARATIONS_ACCESS,
  FORMS_WORKSITE_STATUS_DECLARATIONS_CREATE_EDIT_OWN,
  FORMS_WORKSITE_STATUS_DECLARATIONS_EDIT_ALL,
  FORMS_NON_CONFORMANCE_REPORTS_ACCESS,
  FORMS_NON_CONFORMANCE_REPORTS_CREATE_EDIT_OWN,
  FORMS_NON_CONFORMANCE_REPORTS_EDIT_ALL,
  FORMS_TR_METERS_ACCESS,
  FORMS_TR_METERS_CREATE_EDIT_OWN,
  FORMS_TR_METERS_EDIT_ALL,
  FORMS_SELF_SUPERVISION_MEMOS_ACCESS,
  FORMS_SELF_SUPERVISION_MEMOS_CREATE_EDIT_OWN,
  FORMS_SELF_SUPERVISION_MEMOS_EDIT_ALL,
  FORMS_SELF_HANDOVER_FORMS_ACCESS,
  FORMS_SELF_HANDOVER_FORMS_CREATE_EDIT_OWN,
  FORMS_SELF_HANDOVER_FORMS_EDIT_ALL,
  FORMS_WORKSITE_JOURNALS_ACCESS,
  FORMS_WORKSITE_JOURNALS_CREATE_EDIT_OWN,
  FORMS_WORKSITE_JOURNALS_EDIT_ALL,
  FORMS_WORKSITE_JOURNALS_SIGN_AS_FOREMAN_IN_CHARGE,
  FORMS_WORKSITE_JOURNALS_SIGN_AS_SUPERVISOR,
  FORMS_HOT_WORK_PERMIT_FORMS_ACCESS,
  FORMS_HOT_WORK_PERMIT_FORMS_CREATE_EDIT_OWN,
  FORMS_HOT_WORK_PERMIT_FORMS_EDIT_ALL,
  FORMS_WEEKLY_REVIEW_FORMS_ACCESS,
  FORMS_WEEKLY_REVIEW_FORMS_CREATE_EDIT_OWN,
  FORMS_WEEKLY_REVIEW_FORMS_EDIT_ALL,
  FORMS_PERSONNEL_LIFT_USAGE_PERMITS_ACCESS,
  FORMS_PERSONNEL_LIFT_USAGE_PERMITS_CREATE_EDIT_OWN,
  FORMS_PERSONNEL_LIFT_USAGE_PERMITS_EDIT_ALL,
  FORMS_SUBSTATION_COMMISSIONING_INSPECTION_REPORTS_ACCESS,
  FORMS_SUBSTATION_COMMISSIONING_INSPECTION_REPORTS_CREATE_EDIT_OWN,
  FORMS_SUBSTATION_COMMISSIONING_INSPECTION_REPORTS_EDIT_ALL,
  FORMS_TEMPLATE_FORMS_ACCESS,
  FORMS_TEMPLATE_FORMS_CREATE_EDIT_OWN,
  FORMS_TEMPLATE_FORMS_EDIT_ALL,
  FORMS_ORIENTATION_FORMS_ACCESS,
  FORMS_ORIENTATION_FORMS_CREATE_EDIT_OWN,
  // NOTE: `forms_orientation_forms_manage` and `forms_orientation_forms_delete`
  // are intentionally NOT here. They are high-impact permissions (edit or
  // soft-delete anyone's orientation record) and live in the main Lomakkeet
  // card alongside `forms_delete` so admins toggle them deliberately — never
  // as a side effect of bulk-granting form-type rights via the dialog's
  // "Anna kaikki" button.
];
